<template>
  <header id="header" :class="['header']">
      <!-- 顶部广告 -->
      <!-- 注意css样式适配 -->
      <el-collapse-transition>
        <a :href="collapseAdInfo.link" target="_blank" class="top_ad" :style="{backgroundImage:'url('+collapseAdInfo.imageUrl+')'}" v-if="isHomePage && collapseAdInfo.isShowTopAd"></a>
        <div class="top_banner" v-if="isShowTopBanner && !collapseAdInfo.isShowTopAd">
          <a :href="bannerInfo.link">
            <!-- 新年礼遇！所有论文服务满3000元立享85折特惠，200元新人红包可叠加！ -->
            {{ bannerInfo.title }}
          </a>
          <div class="banner_right">
            <div class="banner_z">
              <u>
                <a :href="bannerInfo.link" style="color: #FFFFFF; font-size: 20px;">查看详情</a>
                <!-- <a href="https://mp.weixin.qq.com/s/jaq3ImI7iS3Qd6hJg1shfQ" style="color: #FFFFFF; font-size: 20px;">查看详情</a> -->
              </u>
            </div>
            <i class="iconfont iconchacha" @click="closeTopBanner"></i>
          </div>
        </div>
      </el-collapse-transition>
    <div class="header_content">
      <div class="logo_box">
        <a href="https://www.topeditsci.com/home" target="_blank" class="topEdit_logo_a"><i class="iconfont iconziyuan1 topEdit_logo" @click="toTouEdit"></i></a>
        <!-- <i class="iconfont iconziyuan1 topEdit_logo" @click="toTouEdit"></i> -->
        <div class="line"></div>
        <router-link to="/" tag="a" target="_blank"><i class="iconfont iconziyuan iJournal_logo"></i></router-link>
      </div>
      <div class="nav">
        <div class="nav_item text_size_14">
          <router-link tag="span" to="/journal-cooperation" class="item_txt">期刊合作专区</router-link>
          <img class="hot_icon" src="../../../assets/img/hot_icon.png" />
        </div>
        <div class="nav_item text_size_14">
          <router-link tag="span" to="/" exact class="item_txt">期刊详情查询</router-link>
        </div>
        <!-- jane搜索工具 -->
        <div class="nav_item text_size_14">
          <router-link tag="span" to="/jane" class="item_txt">AI智能选刊</router-link>
        </div>
        <!-- 期刊预警与On Hold名单 -->
        <div class="nav_item text_size_14">
          <div class="warning_onhold" @mouseover="isShowWarningMenu = true" @mouseout="isShowWarningMenu = false">
            <router-link tag="span" to="/journal-warning-list" @click.native="handleWarningOnhold" class="item_txt">期刊预警与On Hold名单</router-link>
            <div style="height: 200px;">
              <transition name="el-fade-in-linear">
                <div class="warning_onhold_menu" v-show="isShowWarningMenu">
                  <div class="menu_item">
                    <router-link tag="div" @click.native="handleWarningOnhold" to="/journal-warning-list?tab=0" class="menu_item_content">
                      新锐期刊Under Review预警名单
                    </router-link>
                  </div>
                  <div class="menu_item">
                    <router-link tag="div" @click.native="handleWarningOnhold" to="/journal-warning-list?tab=1" class="menu_item_content">
                      期刊On Hold名单（动态）
                    </router-link>
                  </div>
                  <div class="menu_item">
                    <router-link tag="div" @click.native="handleWarningOnhold" to="/journal-warning-list?tab=2" class="menu_item_content">
                      中科院国际期刊预警名单（历年）
                    </router-link>
                  </div>
                  <div class="menu_item">
                    <router-link tag="div" @click.native="handleWarningOnhold" to="/journal-warning-list?tab=3" class="menu_item_content">
                      2025年中信所国际期刊预警名单
                    </router-link>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <!-- 最新公告 -->
        <!-- <div class="nav_item text_size_14">
          <router-link tag="span" to="/notice" class="item_txt">最新公告</router-link>
        </div> -->
        <div class="nav_item text_size_14">
           <a href="https://ithenticate.topeditsci.com/" class="item_txt" target="_blank">iThenticate查重</a>
        </div>
        <!-- 关于我们 -->
        <div class="nav_item text_size_14">
          <router-link tag="span" to="/aboutus" class="item_txt">关于我们</router-link>
        </div>
        <div class="nav_item text_size_14">
          <!-- 使用v-if isShowUserInfoMenu 会自动变成true, 从而打开 -->
          <div class="user_info" v-show="userPhone" @mouseover="isShowUserInfoMenu = true" @mouseout="isShowUserInfoMenu = false">
            <el-avatar :size="30" :src="userAvatar" />
            <span class="margin-left-10 text_size_14 item_txt">个人中心</span>
            <transition name="el-fade-in-linear">
              <div class="user_info_menu" v-show="isShowUserInfoMenu">
                <div class="menu_item">
                  <router-link tag="div" to="/user/info" class="menu_item_content">
                    个人信息
                  </router-link>
                </div>
                <!-- 账号登录或者微信扫码登录绑定了账号才允许修改密码 -->
                <div class="menu_item" v-if="userPhone">
                  <router-link tag="div" to="/user/account" class="menu_item_content">
                    修改密码
                  </router-link>
                </div>
                <div class="menu_item">
                  <router-link tag="div" to="/user/follow" class="menu_item_content">
                    我的收藏
                  </router-link>
                </div>
                <div class="menu_item">
                  <router-link tag="div" to="/user/comment" class="menu_item_content">
                    我的评论
                  </router-link>
                </div>
                <div class="sign_out" @click="logout">
                  注销登录
                </div>
              </div>
            </transition>
          </div>
          <!-- 点击弹出登录框进行登录 -->
          <div class="login_btn" v-show="!userPhone" @click="openFormDialog">登录/注册</div>
        </div>
      </div>
    </div>
    <!-- 登录、忘记密码、注册、补全信息四个表单dialog -->
    <form-dialog
      :visible.sync="isShowFormDialog"
      :currentComName="currentComName"
      @changeView="changeFormDialogView">
    </form-dialog>
  </header>
</template>

<script>
import cookie from '~/utils/cookie'
import * as api from '~/api'
import formDialog from './form-dialog/form-dialog'
export default {
  name: 'layoutHeader',
  inject: [
    '$showLoading',
    '$hideLoading'
  ],
  data () {
    return {
      // 是否显示用户信息的菜单
      isShowUserInfoMenu: false,
      // 是否显示期刊预警与On Hold名单的菜单
      isShowWarningMenu: false,
      // 是否显示承载表单的dialog
      isShowFormDialog: false,
      // 是否显示顶部banner图
      isShowTopBanner: false,
      bannerInfo: {},
      // 顶部折叠广告
      collapseAdInfo: {
        isShowTopAd: false,
        topAdTimer: null,
        imageUrl: '',
        link: ''
      },
      // 表单dialog当前所显示的组件名字
      currentComName: 'loginForm'
    }
  },
  computed: {
    // 用户头像 (存在localStorage中, 用户下次进入仍然有信息)
    userAvatar () {
      return this.$store.state.userInfo.avatarUrl
    },
    // 用户账号 (存在localStorage中, 用户下次进入仍然有信息)
    userPhone () {
      return this.$store.state.userInfo.userPhone
    },
    isXueshi () {
      return this.$route.path.indexOf('/xueshi-iJournal') === 0
    },
    isHomePage () {
      return ['/', '/home'].includes(this.$route.path)
    },
    // header的padding-top
    headerStyle () {
      const styleObj = {}
      if (this.isHomePage) {
        if (this.collapseAdInfo.isShowTopAd) {
          styleObj.paddingTop = `240px`
          styleObj.paddingTop = `calc(80px + 12.85vw)`
        } else if (this.isShowTopBanner) {
          styleObj.paddingTop = '80px'
        } else {
          styleObj.paddingTop = '0px'
        }
      } else {
        if (this.isShowTopBanner) {
          styleObj.paddingTop = '80px'
        } else {
          styleObj.paddingTop = '0px'
        }
      }
      return styleObj
    }
  },
  components: {
    formDialog
  },
  created () {
    // 监听事件 打开登录框
    this.$bus.on('openFormDialog', this.openFormDialog)

    let token = this.isXueshi ? cookie.get('xueshi-token') : cookie.get('T_j_web_token')
    if (token) {
      // 获取用户信息 提前检测一下token是否过期
      this.getUserInfo()
    }
    this.getBannerInfo()
    this.getCollapseAdInfo()
  },
  methods: {
    // 获取用户信息
    getUserInfo () {
      api.getUserInfo().then(res => {
        if (res.data.code === 0) {
          // console.log('获取用户信息成功-header', res.data.data)
          let userInfo = res.data.data
          this.$store.commit('SET_USER_INFO', userInfo)
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error('获取信息失败')
        console.log(err)
      })
    },
    getBannerInfo () {
      api.getBannerInfo({
        appId: 'yp07b9440f2c22351c69d9a1321e0d50'
      }).then(res => {
        if (res.data.code === 0) {
          if (!res.data.data) return
          this.bannerInfo = res.data.data || {}
          this.isShowTopBanner = true
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 退出登录
    logout () {
      // 清除token
      cookie.remove('T_j_web_token')
      // 清除用户信息
      this.$store.commit('SET_USER_INFO', {
        id: '',
        userPhone: '',
        userName: '',
        nickName: '',
        avatarUrl: '',
        userEmail: '',
        // 学校
        university: '',
        // 专业
        userMajor: ''
      })
    },

    // 打开表单dailog 传入具体要打开哪个dialog
    openFormDialog ({ name = 'loginForm' }) {
      this.currentComName = name
      this.isShowFormDialog = true
    },

    // 改变表单dialog所显示的视图
    changeFormDialogView (viewName) {
      console.log(viewName)
      this.currentComName = viewName
    },

    // 点击投必得的LOGO进入投必得官网
    toTouEdit () {
      window.open('https://www.topeditsci.com/home', '_blank')
    },
    // 关闭顶部banner图
    closeTopBanner () {
      this.isShowTopBanner = false
    },
    getCollapseAdInfo () {
      if (!this.isHomePage) return

      api.getCollapseAdInfo({
        appId: 'yp07b9440f2c22351c69d9a1321e0d50'
      }).then(res => {
        if (res.data.code === 0 && res.data.data) {
          const { imageUrl, link } = res.data.data
          this.collapseAdInfo = { ...this.collapseAdInfo, isShowTopAd: true, imageUrl, link }
          this.collapseAdInfo.topAdTimer && clearTimeout(this.collapseAdInfo.topAdTimer)

          this.collapseAdInfo.topAdTimer = setTimeout(() => {
            this.collapseAdInfo.isShowTopAd = false
          }, 5000)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleWarningOnhold () {
      this.isShowWarningMenu = false
    }
  },
  // 页面销毁的时候 取消监听
  beforeDestroy () {
    this.$bus.off('openFormDialog')
  }
}
</script>

<style lang="scss" scoped>
  .header {
    // flex: none;
    // display: flex;
    // height: 51px;
    // height: 131px;
    border-bottom: 1px solid $border-color-base;
    // align-items: center;
    background-color: #FFFFFF;
    .top_ad {
      display: block;
      height: 12.85vw;
      background-size: cover;
      background-position: 50%;
      background-repeat: no-repeat;
    }
    .top_banner {
        position: relative;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        justify-content: center;
        //padding: 0 60px;
        width: 100%;
        height: 60px;
        background-color: #0FA4B3;
        color: #FFFFFF;
        font-weight: 700;
        font-size: 26px;
        letter-spacing: 1.7px;
        // @media (min-width: 1320px) {
        //   font-size: 20px;
        // }
        // @media (min-width: 1525px) {
        //   font-size: 24px;
        // }
        // @media (min-width: 1600px) {
        //   font-size: 26px;
        // }
        & > a {
          color: #FFFFFF;
          font-size: 20px;
        }
        .banner_left {
          display: flex;
           & > h1 {
            font-size: 26px;
            font-weight: bold;
            color: #FFFFFF;
            margin-bottom: 5px;
            text-align: center;
            letter-spacing: 1.7px;
          }
          // padding-top: 15px;
          .col_item {
            & > h1 {
              font-size: 18px;
              font-weight: bold;
              color: #FFFFFF;
              margin-bottom: 5px;
            }
            & > p {
              font-size: 16px;
              color: #FFFFFF;
            }
          }
          .line {
            width: 4px;
            height: 36px;
            background: #FFFFFF;
            margin: 4px 60px 0 60px;
            border-radius: 6px;
          }
        }
        .banner_right {
          position: absolute;
          right: 60px;
          top: 50%;
          transform: translateY(-50%);
          // justify-self: flex-end;
          display: flex;
          height: 22px;
          align-items: center;
          & > a {
            font-size: 20px;
            font-weight: bold;
            line-height: 22px;
            color: #FFFFFF;
            text-decoration: underline;
            margin-right: 20px;
          }
          & > i {
            color: #ffffff;
            font-size: 20px;
            cursor: pointer;
          }
          .banner_z {
          margin-right: 40px;
        }
        }
      }
    .header_content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 51px;
      width: 1280px;
      padding: 0 50px;
      margin: 0 auto;
      .logo_box {
        display: flex;
        .topEdit_logo_a {
          margin-top: 4px;
          .topEdit_logo{
            width: 115px;
            height: 26px;
            line-height: 26px;
            font-size: 26px;
            color: #0083ca;
            cursor: pointer;
          }
        }
        .line {
          width:1px;
          height:30px;
          background:rgba(0,0,0,0.2);
          margin: 0 16px;
        }
        .iJournal_logo {
          width: 82px;
          height: 26px;
          line-height: 26px;
          font-size: 26px;
          color: $color-primary;
          cursor: pointer;
          margin-bottom: 4px;
          cursor: pointer;
        }
      }
      .nav {
        display: flex;
        align-items: center;
        height: 100%;
        .nav_item {
          position: relative;
          display: flex;
          align-items: center;
          height: 30px;
          padding: 0 20px;
          cursor: pointer;
          &:last-child {
            padding-right: 0;
          }
          .item_txt {
            color: $color-text-regular;
            transition: all 0.3s ease;
            &:hover {
              color: $color-primary;
            }
            &.link-active {
              color: $color-primary;
            }
          }
          .warning_onhold {
            display: flex;
            align-items: center;
            height: 50px;
            position: relative;
            &_menu {
              position: absolute;
              top: 50px;
              right: -66px;
              width: 240px;
              background-color: white;
              box-shadow:0px 0px 6px rgba(0,0,0,0.16);
              z-index: 100;
              .menu_item {
                height: 50px;
                padding-left: 20px;
                transition: all 0.3s ease;
                color: $color-text-regular;
                &:hover {
                  color: $color-primary;
                  background-color: #F2F5F9;
                }
                .menu_item_content {
                  display: flex;
                  height: 100%;
                  align-items: center;
                  border-bottom: 1px solid #F2F5F9;
                }
              }
            }
          }
          .user_info {
            display: flex;
            align-items: center;
            height: 50px;
            position: relative;
            .user_info_menu {
              position: absolute;
              top: 50px;
              right: -20px;
              width: 180px;
              // height: 260px;
              background-color: white;
              box-shadow:0px 0px 6px rgba(0,0,0,0.16);
              z-index: 100;
              .menu_item {
                height: 50px;
                padding-left: 20px;
                transition: all 0.3s ease;
                color: $color-text-regular;
                &:last-child {
                  .menu_item_content {
                    border: none;
                  }
                }
                &:hover {
                  color: $color-primary;
                  background-color: #F2F5F9;
                }
                .menu_item_content {
                  display: flex;
                  height: 100%;
                  align-items: center;
                  border-bottom: 1px solid #F2F5F9;
                }
              }
              .sign_out {
                display: flex;
                align-items: center;
                height: 60px;
                padding-left: 20px;
                border-top: 10px solid #F2F5F9;
                color: $color-text-regular;
                &:hover {
                  color: $color-primary;
                  // background-color: #F2F5F9;
                }
              }
            }
          }
          .login_btn {
            display: flex;
            align-items: center;
            padding: 0 5px;
            height:32px;
            background: $color-primary;
            font-size: 14px;
            color: white;
            transition: all 0.3s ease;
            &:hover {
              color: #ffffff;
              background-color: #3fb6c2;
            }
          }
          .hot_icon {
            position: absolute;
            width: 25.5px;
            height: 12px;
            top: -6px;
            right: 1px;
          }
        }
        .nav_item+.nav_item, a+.nav_item, .nav_item+a {
          border-left: 1px solid rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/index.vue